var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZupaylogomain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3033_8864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.3587L3.6937 0H28.3577C33.7272 0 37.3031 5.53855 35.0859 10.4214L29.4018 22.9386H37.0848L33.2432 33.9286H8.72544C3.31896 33.9286 -0.256159 28.3203 2.0328 23.4301L7.68289 11.3587H0Z",
    fill: "#FF8C3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.3587L3.6937 0H28.3577C33.7272 0 37.3031 5.53855 35.0859 10.4214L29.4018 22.9386H37.0848L33.2432 33.9286H8.72544C3.31896 33.9286 -0.256159 28.3203 2.0328 23.4301L7.68289 11.3587H0Z",
    fill: "url(#paint0_linear_3033_8864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0831 14.0144L18.2804 5.97461L10.3701 20.2839L21.137 19.9151L19.8918 27.9548L27.7288 14.0144H16.0831Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3033_8864",
    x1: 3.78168,
    y1: 5.84338,
    x2: 32.1239,
    y2: 13.4411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB3A00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3033_8864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZupaylogomain);
export default __webpack_public_path__ + "static/media/zupaylogomain.51bf336094c95ebb7d097e307f09db43.svg";
export { ForwardRef as ReactComponent };